// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as Svg from "../../primitives/Svg.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../feedback-indicators/Badge.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Burger from "./Burger.res.js";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Offset from "../layout-and-structure/Offset.res.js";
import * as Popover from "../overlays/Popover.res.js";
import * as Tooltip from "../overlays/Tooltip.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as IconButton from "../actions/IconButton.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import Nav_default_profilePng from "./Nav_default_profile.png";
import * as UseResizeObserver from "react-aria/private/utils/useResizeObserver";
let initialState = {
  opened: false
};
let context = React.createContext([undefined, param => {}]);
function use() {
  let match = React.useContext(context);
  let state = match[0];
  if (state !== undefined) {
    return [state, match[1]];
  } else {
    return [initialState, param => {}];
  }
}
let make = context.Provider;
let Provider = {
  make: make
};
function getReducer(param) {
  return React.useReducer((state, action) => ({
    opened: !state.opened
  }), initialState);
}
let Context = {
  initialState: initialState,
  context: context,
  use: use,
  Provider: Provider,
  getReducer: getReducer
};
function Nav$HighlightLinkIcon(props) {
  return JsxRuntime.jsxs(Svg.make, {
    children: [JsxRuntime.jsx(Svg.Path.make, {
      d: "M2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6Z",
      fill: "#fefefe"
    }), JsxRuntime.jsx(Svg.Path.make, {
      d: "M6 10V8C4.89543 8 4 7.10457 4 6H2H0C0 9.31371 2.68629 12 6 12V10ZM10 6H8C8 7.10457 7.10457 8 6 8V10V12C9.31371 12 12 9.31371 12 6H10ZM6 2V4C7.10457 4 8 4.89543 8 6H10H12C12 2.68629 9.31371 0 6 0V2ZM6 2V0C2.68629 0 0 2.68629 0 6H2H4C4 4.89543 4.89543 4 6 4V2Z",
      fill: "#fefefe",
      transform: "scale(0.9)"
    }), JsxRuntime.jsx(Svg.Path.make, {
      d: "M6 2.40039C7.98822 2.40039 9.59961 4.01177 9.59961 6C9.59961 7.98822 7.98822 9.59961 6 9.59961C4.01177 9.59961 2.40039 7.98822 2.40039 6C2.40039 4.01177 4.01177 2.40039 6 2.40039ZM6 6.7998C5.77909 6.7998 5.59961 6.97928 5.59961 7.2002C5.59971 7.42102 5.77915 7.59961 6 7.59961H6.00293C6.22378 7.59961 6.40321 7.42102 6.40332 7.2002C6.40332 6.97928 6.22384 6.7998 6.00293 6.7998H6ZM6 4.40039C5.77915 4.40039 5.59971 4.57898 5.59961 4.7998V6C5.59961 6.22091 5.77909 6.40039 6 6.40039C6.22091 6.40039 6.40039 6.22091 6.40039 6V4.7998C6.40029 4.57898 6.22085 4.40039 6 4.40039Z",
      fill: "#e61e5a"
    })],
    width: 30 .toString(),
    height: 30 .toString(),
    viewBox: "0 0 20 20",
    style: props.style
  });
}
let styles = {
  NavTextIcon_text: {
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "marginLeft-koQZXg": "marginLeft-x1iog12x",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:105"
  },
  textActive: {
    "color-kMwMTN": "color-xbp64b2",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:109"
  },
  textHovered: {
    "color-kMwMTN": "color-x1wohto9",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:112"
  },
  textImportant: {
    "color-kMwMTN": "color-xpzg10a",
    "font-kVVagm": "font-x36xucc",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:115"
  },
  textPrimary: {
    "color-kMwMTN": "color-x1qqs05d",
    "font-kVVagm": "font-xo1i70s",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:119"
  }
};
function textStyleFromParams(variation, active, hovered) {
  if (variation === "important") {
    return styles.textImportant;
  } else if (variation === "primary") {
    if (active) {
      return [styles.textPrimary, styles.textActive];
    } else if (hovered) {
      return [styles.textPrimary, styles.textHovered];
    } else {
      return styles.textPrimary;
    }
  } else {
    return styles.textPrimary;
  }
}
function iconColorFromParams(active, hovered, navOpened) {
  if (active) {
    return "#25243a";
  } else if (hovered) {
    if (navOpened) {
      return "#535165";
    } else {
      return "#25243a";
    }
  } else {
    return "#8c8B9b";
  }
}
let make$1 = React.memo(props => {
  let displayHighlightLinkIcon = props.displayHighlightLinkIcon;
  let __hovered = props.hovered;
  let __variation = props.variation;
  let __sectionOpened = props.sectionOpened;
  let __disabled = props.disabled;
  let __active = props.active;
  let children = props.children;
  let active = __active !== undefined ? __active : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let sectionOpened = __sectionOpened !== undefined ? __sectionOpened : false;
  let variation = __variation !== undefined ? __variation : "primary";
  let hovered = __hovered !== undefined ? __hovered : false;
  let match = use();
  let nav = match[0];
  let match$1 = Hover.use(undefined, undefined, undefined);
  let hovered$1 = match$1[1];
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-x1q0g3np justifyContent-x1nhvcw1 minHeight-xu0aao5",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:97"
    }
  };
  newrecord.ref = Primitive_option.some(match$1[0]);
  let match$2 = !nav.opened;
  let tmp;
  if (nav.opened) {
    let newrecord$1 = {
      ...Stylex.props(styles.NavTextIcon_text, textStyleFromParams(variation, active, hovered$1 || hovered))
    };
    tmp = JsxRuntime.jsx("span", (newrecord$1.children = children, newrecord$1));
  } else {
    let textContent = children.replace("&#x27;", "'");
    tmp = JsxRuntime.jsx(Tooltip.make, {
      placement: "start",
      offset: -4,
      crossOffset: 1,
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: disabled ? I18n.t("Restricted access") : textContent
      }),
      disabled: sectionOpened,
      delay: 0,
      opened: hovered$1
    });
  }
  newrecord.children = [JsxRuntime.jsxs(Box.make, {
    children: [JsxRuntime.jsx(LegacyIcon.make, {
      name: props.icon,
      fill: variation === "important" ? "#fefefe" : iconColorFromParams(active, hovered$1 || hovered, nav.opened)
    }), match$2 && displayHighlightLinkIcon !== undefined && displayHighlightLinkIcon ? JsxRuntime.jsx(Nav$HighlightLinkIcon, {
      style: {
        position: "absolute",
        right: "-15px",
        top: "0px"
      }
    }) : null],
    spaceX: "normal"
  }), tmp];
  return JsxRuntime.jsxs("div", newrecord);
});
function contentStyleFromParams(opened) {
  return {
    0: {
      className: "overflow-xb3r6kr maxHeight-xnjgh8c",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:226; wino-gc:src/resources/navigation/Nav.res.js:230"
    },
    1: {
      className: "maxHeight-x1imav3m overflow-xb3r6kr",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:226"
    }
  }[!!opened << 0];
}
function Nav$NavSection(props) {
  let __disabled = props.disabled;
  let displayHighlightLinkIcon = props.displayHighlightLinkIcon;
  let icon = props.icon;
  let active = props.active;
  let title = props.title;
  let children = props.children;
  let disabled = __disabled !== undefined ? __disabled : false;
  let nav = use()[0];
  let url = Navigation.useUrl();
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let match$1 = React.useState(() => false);
  let setOpened = match$1[1];
  let opened = match$1[0];
  let match$2 = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match$2.ref;
  let popoverAriaProps = match$2.ariaProps;
  let popover = match$2.state;
  React.useEffect(() => {
    if (!nav.opened) {
      setOpened(param => false);
    }
  }, [nav.opened]);
  React.useEffect(() => {
    popover.close();
  }, [url.pathname]);
  let tmp;
  if (nav.opened) {
    let newrecord = {
      ...{
        className: "height-x5kalc8 justifyContent-xl56j7k",
        "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:222"
      }
    };
    tmp = JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsxs("div", (newrecord.ref = Primitive_option.some(match[0]), newrecord.children = [JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(make$1, {
          children: title,
          icon: icon,
          active: active,
          hovered: hovered
        }), JsxRuntime.jsx(LegacyIcon.make, {
          name: opened ? "arrow_up_light" : "arrow_down_light",
          fill: hovered || active ? "#535165" : "#a2a1b0"
        })],
        align: "spaceBetween"
      }), displayHighlightLinkIcon !== undefined && displayHighlightLinkIcon ? JsxRuntime.jsx(Nav$HighlightLinkIcon, {
        style: {
          position: "absolute",
          right: "-23px",
          top: "6px"
        }
      }) : null], newrecord)),
      disabled: disabled,
      onPress: param => setOpened(opened => !opened)
    });
  } else {
    let newrecord$1 = {
      ...{
        className: "height-x5kalc8 justifyContent-xl56j7k",
        "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:222"
      }
    };
    tmp = JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsx("div", (newrecord$1.ref = Primitive_option.some(popoverTriggerRef), newrecord$1.children = JsxRuntime.jsx(make$1, {
        children: title,
        icon: icon,
        active: active,
        disabled: disabled,
        sectionOpened: popover.isOpen,
        hovered: hovered,
        displayHighlightLinkIcon: displayHighlightLinkIcon
      }), newrecord$1)),
      ariaProps: popoverAriaProps.triggerProps,
      disabled: disabled
    });
  }
  let newrecord$2 = {
    ...contentStyleFromParams(opened)
  };
  let newrecord$3 = {
    ...{
      className: "paddingBottom-xjkvuk6 paddingInline-xaope02",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:233"
    }
  };
  newrecord$2.children = JsxRuntime.jsx("div", (newrecord$3.children = children, newrecord$3));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [tmp, JsxRuntime.jsx("div", newrecord$2), popover.isOpen ? JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsx(Popover.Dialog.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: children,
          spaceX: "medium",
          spaceY: "small"
        }),
        ariaProps: popoverAriaProps.overlayProps
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      variation: "arrowed",
      placement: "end",
      modal: false,
      offset: 4,
      crossOffset: -2
    }) : null]
  });
}
let make$2 = React.memo(Nav$NavSection);
let styles$2 = {
  label: {
    "font-kVVagm": "font-xo1i70s",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:348"
  },
  labelNormal: {
    "color-kMwMTN": "color-x1qqs05d",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:351"
  },
  labelNormalHovered: {
    "color-kMwMTN": "color-x1wohto9",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:354"
  },
  labelImportant: {
    "color-kMwMTN": "color-x1dxcrjc",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:357"
  },
  labelImportantHovered: {
    "color-kMwMTN": "color-xgyeus4",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:360"
  }
};
function labelStyleFromParams(variation, hovered) {
  return Stylex.props(styles$2.label, variation === "normal" ? hovered ? styles$2.labelNormalHovered : styles$2.labelNormal : hovered ? styles$2.labelImportantHovered : styles$2.labelImportant);
}
let make$3 = React.memo(props => {
  let __variation = props.variation;
  let icon = props.icon;
  let onPress = props.onPress;
  let label = props.label;
  let variation = __variation !== undefined ? __variation : "normal";
  let match = Hover.use(undefined, undefined, undefined);
  let tmp;
  if (label !== undefined && onPress !== undefined) {
    if (icon !== undefined) {
      tmp = JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(make$1, {
          children: label,
          icon: icon
        }),
        onPress: param => onPress()
      });
    } else {
      let newrecord = {
        ...labelStyleFromParams(variation, match[1])
      };
      tmp = JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx("span", (newrecord.children = label, newrecord)),
          spaceY: "small"
        }),
        onPress: param => onPress()
      });
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    ref: Primitive_option.some(match[0])
  });
});
let defaultProfilePictureUri = Nav_default_profilePng;
let containerSize = "32px";
function profilePictureFromParams(hovered, active) {
  return {
    0: {
      style: {
        borderColor: "#e7e7ee",
        borderRadius: "50px",
        borderStyle: "solid",
        borderWidth: "1px",
        height: "30px",
        width: "30px"
      }
    },
    2: {
      style: {
        borderRadius: "50px",
        height: "30px",
        width: "30px",
        borderColor: "#bdbdca",
        borderStyle: "solid",
        borderWidth: "1px"
      }
    },
    1: {
      style: {
        borderRadius: "50px",
        height: "30px",
        width: "30px",
        borderColor: "#a2a1b0",
        borderStyle: "solid",
        borderWidth: "1px"
      }
    },
    3: {
      style: {
        borderRadius: "50px",
        height: "30px",
        width: "30px",
        borderColor: "#a2a1b0",
        borderStyle: "solid",
        borderWidth: "1px"
      }
    }
  }[!!hovered << 1 | !!active << 0];
}
function containerStyleFromParams(opened) {
  return {
    0: {
      className: "alignItems-x6s0dn4 display-x78zum5 height-x10w6t97 width-x1td3qas",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:442; wino-gc:src/resources/navigation/Nav.res.js:447"
    },
    1: {
      className: "alignItems-x6s0dn4 display-x78zum5 height-x10w6t97",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:442"
    }
  }[!!opened << 0];
}
function moreViewStyleFromParams(opened) {
  return {
    0: {
      className: "backgroundColor-xhb2u9n borderTopColor-x1eit1tb borderTopStyle-x13fuv20 borderTopWidth-x178xt8z transition-x1rovq4h maxHeight-xnjgh8c",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:420; wino-gc:src/resources/navigation/Nav.res.js:430"
    },
    1: {
      className: "backgroundColor-xhb2u9n borderTopColor-x1eit1tb borderTopStyle-x13fuv20 borderTopWidth-x178xt8z transition-x18pzcsc maxHeight-xuyqlj2",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:420; wino-gc:src/resources/navigation/Nav.res.js:426"
    }
  }[!!opened << 0];
}
function Nav$NavFooter(props) {
  let children = props.children;
  let match = use();
  let nav = match[0];
  let url = Navigation.useUrl();
  let match$1 = Hover.use(undefined, undefined, undefined);
  let hoveredProfilePicture = match$1[1];
  let match$2 = React.useState(() => false);
  let setMoreOpened = match$2[1];
  let moreOpened = match$2[0];
  let match$3 = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match$3.ref;
  let popover = match$3.state;
  React.useEffect(() => {
    popover.close();
  }, [url.pathname]);
  React.useEffect(() => {
    if (!nav.opened) {
      setMoreOpened(param => false);
    }
  }, [nav.opened]);
  let handleFooterPress = param => {
    if (nav.opened) {
      return setMoreOpened(moreOpened => !moreOpened);
    } else {
      return popover.toggle();
    }
  };
  let newrecord = {
    ...moreViewStyleFromParams(moreOpened)
  };
  let newrecord$1 = {
    ...{
      className: "borderBottomColor-xmf12dl borderBottomStyle-x1q0q8m5 borderBottomWidth-xso031l marginInline-x1akc8e4 paddingBlock-x1xn8qrt paddingInline-x5k8d2m",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:434"
    }
  };
  newrecord.children = JsxRuntime.jsx("div", (newrecord$1.children = children, newrecord$1));
  let newrecord$2 = {
    ...{
      className: "backgroundColor-xhb2u9n height-xng8ra paddingBlock-xxlmvz2 paddingInline-x1hr3lfm",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:414"
    }
  };
  let newrecord$3 = {
    ...containerStyleFromParams(nav.opened)
  };
  newrecord$3.ref = Primitive_option.some(popoverTriggerRef);
  let newrecord$4 = {
    ...profilePictureFromParams(hoveredProfilePicture && !nav.opened, popover.isOpen)
  };
  let tmp;
  if (nav.opened) {
    let newrecord$5 = {
      ...{
        className: "color-x1qqs05d font-xo1i70s textOverflow-xlyipyv whiteSpace-xuxw1ft flex-x98rzlu overflow-xb3r6kr paddingInline-xaope02 width-xh8yej3",
        "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:450"
      }
    };
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx("span", (newrecord$5.children = props.userName, newrecord$5)), JsxRuntime.jsx(IconButton.make, {
        name: moreOpened ? "arrow_down_light" : "arrow_up_light",
        marginSize: "xsmall",
        color: hoveredProfilePicture ? "#535165" : "#a2a1b0",
        hoveredColor: "#535165",
        onPress: handleFooterPress
      })]
    });
  } else {
    tmp = popover.isOpen ? JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsx(Popover.Dialog.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: children,
          spaceX: "medium",
          spaceY: "small"
        }),
        ariaProps: match$3.ariaProps.overlayProps
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      variation: "arrowed",
      placement: "end",
      offset: 8
    }) : null;
  }
  newrecord$3.children = [JsxRuntime.jsx("img", (newrecord$4.src = Stdlib_Option.getOr(props.userProfilePictureUri, defaultProfilePictureUri), newrecord$4)), tmp];
  newrecord$2.children = JsxRuntime.jsxs("div", newrecord$3);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx("div", newrecord), JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsx("div", newrecord$2),
      onPress: handleFooterPress,
      ref: match$1[0]
    })]
  });
}
let make$4 = React.memo(Nav$NavFooter);
function restrictedAccessIcon(hovered) {
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Offset.make, {
      children: JsxRuntime.jsx("svg", {
        children: JsxRuntime.jsx("path", {
          clipRule: "evenodd",
          d: "M10 2C12.2091 2 14 3.79086 14 6V8H15C16.1046 8 17 8.89543 17 10V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V10C3 8.89543 3.89543 8 5 8H6V6C6 3.79086 7.79086 2 10 2ZM5 16H15V10H5V16ZM10 4C8.89543 4 8 4.89543 8 6V8H12V6C12 4.89543 11.1046 4 10 4Z",
          fill: hovered ? "#25243a" : "#797885",
          fillRule: "evenodd"
        }),
        height: "16px",
        width: "16px",
        viewBox: "0 0 20 20"
      }),
      top: -1,
      left: -2,
      width: 16,
      height: 16
    }),
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Restricted access")
    })
  });
}
let styles$4 = {
  NavLink_view: {
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "height-kZKoxP": "height-x5kalc8",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:601"
  },
  viewImportant: {
    "backgroundColor-kWkggS": "backgroundColor-x1aui6ha",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:605"
  },
  viewImportantHovered: {
    "backgroundColor-kWkggS": "backgroundColor-x1x0a3j4",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:608"
  },
  viewPrimary: {
    "backgroundColor-kWkggS": "backgroundColor-xjbqb8w",
    $$css: "wino-gc:src/resources/navigation/Nav.res.js:611"
  }
};
function viewStyleFromParams(variation, hovered, navOpened) {
  return Stylex.props(styles$4.NavLink_view, variation === "important" ? hovered ? styles$4.viewImportantHovered : styles$4.viewImportant : styles$4.viewPrimary);
}
function labelStyleFromParams$1(active, hovered) {
  return {
    0: {
      className: "color-x1qqs05d font-xo1i70s paddingBlock-x1vvogim",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:614"
    },
    1: {
      className: "font-xo1i70s paddingBlock-x1vvogim color-xbp64b2",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:614; wino-gc:src/resources/navigation/Nav.res.js:619"
    }
  }[!!(!active && hovered || active && !hovered || active && hovered) << 0];
}
function Nav$NavLink(props) {
  let __variation = props.variation;
  let __disabled = props.disabled;
  let __restrictedMode = props.restrictedMode;
  let __displayHighlightLinkIcon = props.displayHighlightLinkIcon;
  let __betaBadge = props.betaBadge;
  let __icon = props.icon;
  let label = props.label;
  let icon = __icon !== undefined ? __icon : "ticket_bold";
  let betaBadge = __betaBadge !== undefined ? __betaBadge : false;
  let displayHighlightLinkIcon = __displayHighlightLinkIcon !== undefined ? __displayHighlightLinkIcon : false;
  let restrictedMode = __restrictedMode !== undefined ? __restrictedMode : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let variation = __variation !== undefined ? __variation : "secondary";
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let match$1 = use();
  let tmp;
  if (variation === "primary" || variation === "important") {
    let newrecord = {
      ...viewStyleFromParams(variation, hovered, match$1[0].opened)
    };
    tmp = JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(make$1, {
      children: label,
      icon: icon,
      disabled: restrictedMode,
      variation: variation
    }), newrecord));
  } else {
    let newrecord$1 = {
      ...labelStyleFromParams$1(props.active, hovered)
    };
    tmp = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("span", (newrecord$1.children = label, newrecord$1)), betaBadge ? JsxRuntime.jsx(Badge.make, {
        children: I18n.t("BETA"),
        size: "small",
        variation: "information"
      }) : null, restrictedMode ? restrictedAccessIcon(hovered) : null, displayHighlightLinkIcon ? JsxRuntime.jsx(Tooltip.make, {
        children: JsxRuntime.jsx(LegacyIcon.make, {
          name: "warning",
          fill: hovered ? "#ce0340" : "#e61e5a",
          size: 16
        }),
        content: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Pending action")
        })
      }) : null],
      space: "small"
    });
  }
  return JsxRuntime.jsx(Navigation.Link.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Inline.make, {
        children: tmp,
        space: "medium",
        align: "spaceBetween"
      }),
      ref: Primitive_option.some(match[0])
    }),
    to: props.to,
    disabled: disabled
  });
}
function rootStyleFromParams(opened) {
  return {
    0: {
      className: "backgroundColor-x17suf5r transition-x1jdyi3z boxShadow-xf5azjg bottom-x1ey2m1c display-x78zum5 left-xu96u03 overflow-xb3r6kr position-xixxii4 top-x13vifvy width-x1fu8urw zIndex-x1vjfegm",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:700"
    },
    1: {
      className: "backgroundColor-x17suf5r transition-x1jdyi3z boxShadow-xf5azjg bottom-x1ey2m1c display-x78zum5 left-xu96u03 overflow-xb3r6kr position-xixxii4 top-x13vifvy zIndex-x1vjfegm width-x1rva8in",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:700; wino-gc:src/resources/navigation/Nav.res.js:713"
    }
  }[!!opened << 0];
}
function contentStyleFromParams$1(opened) {
  return {
    0: {
      className: "transition-x1jdyi3z scrollbarWidth-x1597r2g flex-x98rzlu overflow-xysyzu8 overflowX-x6ikm8r paddingLeft-x163pfp paddingRight-x15h74y paddingTop-xyamay9 width-x1fu8urw",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:744"
    },
    1: {
      className: "transition-x1jdyi3z scrollbarWidth-x1597r2g flex-x98rzlu overflow-xysyzu8 overflowX-x6ikm8r paddingLeft-x163pfp paddingRight-x15h74y paddingTop-xyamay9 width-xh8yej3",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:744; wino-gc:src/resources/navigation/Nav.res.js:755"
    }
  }[!!opened << 0];
}
let contentScrollShadeOverlay = {
  backgroundImage: "radial-gradient(ellipse at center, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 75%)",
  backgroundPosition: "center top",
  borderBottom: "1px solid #f3f3f7",
  height: "16px",
  marginTop: "-16px",
  backgroundSize: "100% 200%",
  boxSizing: "border-box",
  pointerEvents: "none"
};
function Nav(props) {
  let onRequestLogout = props.onRequestLogout;
  let onToggleHelpCenter = props.onToggleHelpCenter;
  let userSettingsRoute = props.userSettingsRoute;
  let userImpersonating = props.userImpersonating;
  let badge = props.badge;
  let match = use();
  let dispatch = match[1];
  let nav = match[0];
  let match$1 = Navigation.useUrl();
  let match$2 = React.useState(() => false);
  let setScrollable = match$2[1];
  let ref = React.useRef(null);
  let handleScrollable = React.useCallback(() => {
    let domElement = ref.current;
    if (domElement == null) {
      return;
    }
    let hasNotReachedBottom = ((domElement.scrollTop | 0) + domElement.clientHeight | 0) < domElement.scrollHeight;
    setScrollable(param => hasNotReachedBottom);
  }, [ref]);
  React.useLayoutEffect(() => {
    let bodyDomElement = ReactDomElement.fromRef(ref);
    handleScrollable();
    Stdlib_Option.forEach(bodyDomElement, domNode => {
      domNode.addEventListener("scroll", handleScrollable);
    });
    return () => Stdlib_Option.forEach(bodyDomElement, domEmement => {
      domEmement.removeEventListener("scroll", handleScrollable);
    });
  }, []);
  UseResizeObserver.useResizeObserver({
    ref: ref,
    onResize: handleScrollable
  });
  let newrecord = {
    ...rootStyleFromParams(nav.opened)
  };
  let newrecord$1 = {
    ...{
      className: "display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf width-x1rva8in",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:716"
    }
  };
  let newrecord$2 = {
    ...{
      className: "borderBottomColor-xmf12dl borderBottomStyle-x1q0q8m5 borderBottomWidth-xso031l alignItems-x6s0dn4 display-x78zum5 height-xng8ra justifyContent-x1qughib",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:722"
    }
  };
  let newrecord$3 = {
    ...{
      className: "marginLeft-x16ydxro",
      "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:731"
    }
  };
  let tmp;
  if (nav.opened) {
    let newrecord$4 = {
      ...{
        className: "alignItems-xuk3077 display-x78zum5 flexDirection-xdt5ytf paddingRight-xnuq7ks",
        "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:738"
      }
    };
    let newrecord$5 = {
      ...{
        className: "color-x1lewwgq font-xmm3etr",
        "data-style-src": "wino-gc:src/resources/navigation/Nav.res.js:734"
      }
    };
    newrecord$4.children = [JsxRuntime.jsx("span", (newrecord$5.children = props.userOrganizationName, newrecord$5)), badge !== undefined ? JsxRuntime.jsx(Box.make, {
      children: badge,
      spaceTop: "xsmall"
    }) : null];
    tmp = JsxRuntime.jsxs("div", newrecord$4);
  } else {
    tmp = null;
  }
  newrecord$2.children = [JsxRuntime.jsx("div", (newrecord$3.children = JsxRuntime.jsx(Burger.make, {
    onPress: () => dispatch("Toggled")
  }), newrecord$3)), tmp];
  let newrecord$6 = {
    ...contentStyleFromParams$1(nav.opened)
  };
  newrecord$1.children = [JsxRuntime.jsxs("div", newrecord$2), JsxRuntime.jsx("div", (newrecord$6.ref = Primitive_option.some(ref), newrecord$6.children = props.children, newrecord$6)), JsxRuntime.jsx(AnimatedRender.make, {
    children: JsxRuntime.jsx("div", {
      style: contentScrollShadeOverlay
    }),
    displayed: match$2[0],
    animation: "fade",
    duration: 250
  }), userImpersonating ? null : JsxRuntime.jsxs(Box.make, {
    children: [JsxRuntime.jsx(make$3, {
      label: I18n.t("Contact us"),
      onPress: () => onToggleHelpCenter(),
      icon: "help_bold"
    }), JsxRuntime.jsx(Navigation.Link.make, {
      children: JsxRuntime.jsx(make$1, {
        children: I18n.t("Help center"),
        icon: "book_bold"
      }),
      to: {
        TAG: "Url",
        _0: props.helpCenterUrl
      },
      openNewTab: true
    })],
    spaceX: "small",
    spaceY: "small"
  }), JsxRuntime.jsxs(make$4, {
    children: [JsxRuntime.jsx(Nav$NavLink, {
      to: {
        TAG: "Route",
        _0: userSettingsRoute
      },
      label: I18n.t("Your account"),
      active: match$1.pathname === userSettingsRoute
    }), JsxRuntime.jsx(make$3, {
      label: I18n.t("Sign out"),
      onPress: () => onRequestLogout(),
      variation: "important"
    })],
    userName: props.userName,
    userProfilePictureUri: userImpersonating ? "/impersonating_user.png" : props.userProfilePictureUri
  })];
  newrecord.children = JsxRuntime.jsxs("div", newrecord$1);
  return JsxRuntime.jsx("div", newrecord);
}
let NavSection = {
  make: make$2
};
let NavLink = {
  make: Nav$NavLink
};
let openedSize = 262;
let closedSize = 64;
let make$5 = Nav;
export { Context, NavSection, NavLink, openedSize, closedSize, make$5 as make };
/* context Not a pure module */